import { SkeletonRows } from "../../../UI/DesignStandards";
import PrizeFundDistributionItem from "./PrizeFundDistributionItem";

const PrizeFundDistributionList = ({
  isLoading,
  combinedEventData,
  isRefreshing,
  isSubmitting,
  editMode,
  validationErrors,
  isPayoutFinalized,
  onPrizeAmountChange,
}) => {
  if (isLoading && !isRefreshing) {
    return (
      <div className="py-4">
        <SkeletonRows count={3} />
      </div>
    );
  }

  if (combinedEventData.length === 0) {
    return (
      <div className="text-center py-12 card-inset">
        <div className="mx-auto h-12 w-12 text-brand-muted mb-4">
          <svg fill="currentColor" viewBox="0 0 20 20">
            <path d="M8.433 7.418c.155-.103.346-.196.567-.267v1.698a2.305 2.305 0 01-.567-.267C8.07 8.34 8 8.114 8 8c0-.114.07-.34.433-.582zM11 12.849v-1.698c.22.071.412.164.567.267.364.243.433.468.433.582 0 .114-.07.34-.433.582a2.305 2.305 0 01-.567.267z" />
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <h3 className="heading-display text-lg mb-2">
          No events available for prize fund distribution
        </h3>
        <p className="text-sm text-brand-muted">
          Events need to be created before you can assign prize funds.
        </p>
      </div>
    );
  }

  return (
    <div className="mt-6 pt-6 border-t border-brand-charcoal/10">
      {isRefreshing && (
        <div className="flex justify-center items-center py-2 mb-3">
          <div className="flex items-center gap-2 text-sm text-brand-muted">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-gold-ink"></div>
            Updating...
          </div>
        </div>
      )}

      {isSubmitting && (
        <div className="flex justify-center items-center py-2 mb-3">
          <div className="flex items-center gap-2 text-sm text-brand-muted">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-gold-ink"></div>
            Saving changes...
          </div>
        </div>
      )}

      <div className="space-y-3">
        {combinedEventData.map((item) => (
          <PrizeFundDistributionItem
            key={item.id}
            item={item}
            editMode={editMode}
            validationErrors={validationErrors}
            isPayoutFinalized={isPayoutFinalized}
            onPrizeAmountChange={onPrizeAmountChange}
            isSubmitting={isSubmitting}
          />
        ))}
      </div>
    </div>
  );
};

export default PrizeFundDistributionList;
